// Firebase Cloud Messaging Service for Web Push Notifications
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCZlnxLCQEh0NPWFmLLngHUdxgAyT3NDu4',
  authDomain: 'quali-d-8bef6.firebaseapp.com',
  projectId: 'quali-d-8bef6',
  storageBucket: 'quali-d-8bef6.firebasestorage.app',
  messagingSenderId: '195833008360',
  appId: '1:195833008360:web:668a9430c49e10b113f95d',
  measurementId: 'G-G92DKL4VMV'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(app)

/**
 * Request permission and get FCM token for web push notifications
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const requestNotificationPermission = async () => {
  try {
    console.log('Requesting notification permission...')

    // Request permission from the user
    const permission = await Notification.requestPermission()

    if (permission === 'granted') {
      console.log('Notification permission granted.')

      // Get registration token
      const token = await getToken(messaging, {
        vapidKey: 'BCqnUv3LUTlDg_rrweHBCSPRIXO7VgA4UqO7nTCf_qTRLd4kXjnIKUeaTsMeKiiTUe-QqP_qIP6OoTV-0uBQazQ'
      })

      if (token) {
        console.log('FCM Token:', token)
        return token
      } else {
        console.log('No registration token available.')
        return null
      }
    } else {
      console.log('Notification permission denied.')
      return null
    }
  } catch (error) {
    console.error('An error occurred while retrieving token:', error)
    return null
  }
}

/**
 * Listen for foreground messages (when app is open)
 * @param {Function} callback - Function to call when message is received
 */
export const onMessageListener = (callback) => {
  onMessage(messaging, (payload) => {
    console.log('Message received in foreground:', payload)

    // Extract notification data
    const notificationTitle = payload.notification?.title || 'New Message'
    const notificationOptions = {
      body: payload.notification?.body || '',
      icon: '/favicon.png',
      badge: '/favicon.png',
      tag: 'whatsapp-message',
      requireInteraction: false,
      data: payload.data
    }

    // Show notification even if app is in foreground
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.showNotification(notificationTitle, notificationOptions)
      })
    }

    // Call the callback with the payload
    if (callback) {
      callback(payload)
    }
  })
}

/**
 * Save FCM token to backend
 * @param {string} token - FCM token
 * @param {string} authToken - User authentication token
 * @returns {Promise<boolean>} Success status
 */
export const saveFCMTokenToBackend = async (token, authToken) => {
  try {
    const response = await fetch('https://api.quali-d.com/save-fcm-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      },
      body: JSON.stringify({
        fcm_token: token,
        platform: 'web'
      })
    })

    const data = await response.json()

    if (data.success) {
      console.log('FCM token saved to backend successfully')
      return true
    } else {
      console.error('Failed to save FCM token:', data.message)
      return false
    }
  } catch (error) {
    console.error('Error saving FCM token to backend:', error)
    return false
  }
}

export { messaging }
